import MuiToggleButton, {
  type ToggleButtonProps as MuiToggleButtonProps,
} from '@mui/material/ToggleButton';
import { form } from '@/shared/theme';
import { mergeSx } from '../utils/mergeSx';

export type ToggleButtonProps = MuiToggleButtonProps;

const baseSx = {
  textTransform: 'none' as const,
  bgcolor: 'common.white',
  color: 'text.primary',
  borderColor: 'divider',
  '&:hover': {
    bgcolor: 'action.hover',
  },
  '&.Mui-selected': {
    bgcolor: 'primary.main',
    color: 'primary.contrastText',
    borderColor: 'divider',
    '&:hover': {
      bgcolor: 'primary.dark',
      color: 'primary.contrastText',
    },
  },
};

const smallSizeSx = {
  ...baseSx,
  height: form.controlHeight,
  minHeight: form.controlHeight,
  py: 0,
  lineHeight: 1.25,
};

/**
 * Shared toggle button. Defaults: size small, white background, primary when selected,
 * sentence-case label. Borders are owned by ToggleButtonGroup to avoid double edges.
 */
const ToggleButton = ({
  size = 'small',
  sx,
  ...props
}: ToggleButtonProps) => (
  <MuiToggleButton
    size={size}
    sx={mergeSx(size === 'small' ? smallSizeSx : baseSx, sx)}
    {...props}
  />
);

export default ToggleButton;
